import MaterialIcon from "@expo/vector-icons/MaterialIcons";

import { Col, TextBody, Icon } from "../lib";
import { browser } from "../services";
import { colors } from "../theme";

export function AddToHome() {
  // Vars
  const isBrowserAndroid = browser.operatingSystem === "Android";

  // Render
  return (
    <Col>
      <TextBody>
        1. Open {isBrowserAndroid ? "Chrome" : "Safari"} menu (
        <Icon
          color="onSurfaceDim"
          name={isBrowserAndroid ? "dots-vertical" : "dots-horizontal"}
        />
        )
      </TextBody>
      {isBrowserAndroid ? (
        <TextBody>
          2. Add to Home screen (
          <Icon color="onSurfaceDim" name="cellphone-arrow-down" />)
        </TextBody>
      ) : (
        <>
          <TextBody mb="1">
            2. Share (
            <MaterialIcon
              color={colors["onSurfaceDim"]}
              size={24}
              name="ios-share"
            />
            )
          </TextBody>
          <TextBody>
            3. Add to Home Screen (
            <Icon color="onSurfaceDim" name="plus-box-outline" />)
          </TextBody>
        </>
      )}
    </Col>
  );
}
